
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Modal from './Modal.vue'
import moment from 'moment'
import FilterBarDownload from '@/components/FilterBarDownload.vue'
import { getTeamPerformanceReport, getTeamPerformanceReportAsync } from '@/api/teamscoreboard'

@Component<TeamPerformanceReportDownload>({
    components: { FilterBarDownload }
})
export default class TeamPerformanceReportDownload extends Vue {

    private async downloadFile() {
        return getTeamPerformanceReport()
    }

    private async downloadFileAsync() {
        return getTeamPerformanceReportAsync()
    }

    private get fileName() {
        return 'AskNicely-Scoreboard-Report-' +  moment(new Date()).format('YYYY-MM-DD') + '.pptx'
    }
}
